import handler from 'api/handler'

const prefix = '/admin/testimony'

const methods = {
  // Create new testimony
  create: args => handler({ method: 'post', url: prefix + '/create', args, isFile: true }),
  
  // Update existing testimony
  update: (id, args) => handler({ method: 'put', url: prefix + `/update/${id}`, args, isFile: true }),
  
  // Delete testimony
  delete: id => handler({ method: 'delete', url: prefix + `/delete/${id}` }),
  
  // Fetch all testimonies
  fetch: args => handler({ method: 'get', url: prefix + '/fetch', args }),
  
  // Fetch single testimony
  fetchById: id => handler({ method: 'get', url: prefix + `/fetch/${id}` }),
  
  // Toggle visibility
  toggleVisibility: args => handler({ method: 'patch', url: prefix + '/toggle-visibility', args })
}

export default methods
